import { useSyncExternalStore } from "react";

// Shared between the provisioning step (left column) and the catalog pane
// (right pane, or inline on mobile): whether the user is actively working
// the catalog, and how many hub connect flows are mid-flight. Drives the
// ready-state handoff — auto-advance to the next onboarding step only when
// the user is passive and nothing is connecting. Module-level because the
// two sides live in separate branches of the layout tree. SPA-session
// scoped; onboarding runs once per account, so staying "engaged" after a
// visit is harmless (it only means the user keeps the manual Continue).
type CatalogActivity = { engaged: boolean; connecting: number };

let activity: CatalogActivity = { engaged: false, connecting: 0 };
const listeners = new Set<() => void>();

function update(next: CatalogActivity) {
  activity = next;
  for (const listener of listeners) listener();
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function useCatalogActivity(): CatalogActivity {
  return useSyncExternalStore(subscribe, () => activity);
}

export function markCatalogEngaged() {
  if (!activity.engaged) update({ ...activity, engaged: true });
}

export function beginCatalogConnect() {
  update({ engaged: true, connecting: activity.connecting + 1 });
}

export function endCatalogConnect() {
  update({ ...activity, connecting: Math.max(0, activity.connecting - 1) });
}
